class GGM_Breadcrumbs extends HTMLElement {

  constructor() {
    super();
    this.product = this.getAttribute('product');
    this.productTitle = this.getAttribute('product-title');
    this.collection = this.getAttribute('collection');
    this.collectionTitle = this.getAttribute('collection-title');
    this.fallback = this.getAttribute('fallback');
    this.fallbackTitle = this.getAttribute('fallback-title');
    this.metafieldBreadcrumb = this.innerHTML ? JSON.parse(this.innerHTML) : null;
    this.lastVisted = JSON.parse(sessionStorage.getItem('lastVisited')) || null;
    this.breadcrumbs = JSON.parse(sessionStorage.getItem('breadcrumbs')) || null;

    if (this.product && this.lastVisted && this.lastVisted.product
      && this.lastVisted.product !== this.product) {
      this.breadcrumbs = null
    }

    this.innerHTML = '';
    if (this.collection && !this.product) this.handleCollection();
    if (this.product) this.handleProduct();
    if (!this.collection && !this.product) this.reset();
  }

  handleCollection() {
    if (this.lastVisted && this.lastVisted.collection === this.collection) return;

    let currentCollection = {
      collection: this.collection,
      title: this.collectionTitle
    }
    sessionStorage.setItem('lastVisited', JSON.stringify(currentCollection));
    if (this.breadcrumbs && this.breadcrumbs.length > 0
      && this.metafieldBreadcrumb && this.metafieldBreadcrumb.length > 0) {
      if (!this.metafieldBreadcrumb.some(mfb => this.breadcrumbs[this.breadcrumbs.length - 1].collection === mfb.collection)) {
        this.breadcrumbs = this.metafieldBreadcrumb;
      }
    }

    if (this.breadcrumbs) {
      if (this.breadcrumbs.length > 1
        && this.breadcrumbs[this.breadcrumbs.length - 2].collection === this.collection) {
        this.breadcrumbs.pop();
      } else {
        this.breadcrumbs.push(currentCollection);
      }
      sessionStorage.setItem('breadcrumbs', JSON.stringify(this.breadcrumbs));
    } else {
      this.breadcrumbs = this.metafieldBreadcrumb;
      this.breadcrumbs.push(currentCollection);
      sessionStorage.setItem('breadcrumbs', JSON.stringify(this.breadcrumbs));
    }
  }

  handleProduct() {
    this.breadcrumbsTitel = this.getAttribute('breadcrumbs-title');
    this.breadcrumbsHome = this.getAttribute('breadcrumbs-home');
    this.rootUrl = this.getAttribute('root-url');
    this.productHistory = JSON.parse(sessionStorage.getItem('productHistory')) || [];

    if (!this.breadcrumbs) {
      this.findProduct = this.productHistory.find((product) => product.product === this.product);

      if (this.findProduct) {
        this.breadcrumbs = this.findProduct.breadcrumbs;
      } else {
        this.breadcrumbs = [
          {
            collection: this.fallback,
            title: this.fallbackTitle
          }
        ]
      }
    } else {
      for (let i = 0; i < this.productHistory.length; i++) {
        if (this.productHistory[i].product === this.product) {
          this.productHistory.splice(i, 1);
          break;
        }
      }

      this.productHistory.push({
        product: this.product,
        breadcrumbs: this.breadcrumbs
      })

      if (this.productHistory.length > 10) {
        this.productHistory.shift();
      }

      sessionStorage.setItem('productHistory', JSON.stringify(this.productHistory));
    }

    sessionStorage.setItem('lastVisited', JSON.stringify({ product: this.product }));
    this.render();
  }


  render() {
    let divider = `<svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      role="presentation"
      class="icon">
      <path
        d="m9.693 4.5 7.5 7.5-7.5 7.5"
        stroke="currentColor"
        stroke-width="1.5"
        fill="none" />
    </svg>`;

    this.innerHTML = `
      <nav
        aria-label="${this.breadcrumbsTitel}">
      <ul class="flex items-center py-5 flex-wrap"
      style="font-size: 14px; padding-left: 0">
        <li class="flex items-center">
          <a href="${this.rootUrl}" class="breadcrumbs-list__link">${this.breadcrumbsHome}</a>
          <span class="icon">${divider}</span>
        </li>
        ${this.breadcrumbs ? this.breadcrumbs.map((breadcrumb) => `
          <li class="flex items-center">
            <a href="/collections/${breadcrumb.collection}" class="breadcrumbs-list__link">${breadcrumb.title}</a>
            <span class="icon">${divider}</span>
          </li>
        `).join('') : ''}
        ${this.product ? `
          <li class="flex items-center">
            <span class="breadcrumbs-list__link" aria-current="page">${this.productTitle}</span>
          </li>
        ` : ''}
      </ul>
    `;

    this.style.display = 'block';
  }

  reset() {
    sessionStorage.removeItem('lastVisited');
    sessionStorage.removeItem('breadcrumbs');
  }

}

customElements.define('ggm-breadcrumbs', GGM_Breadcrumbs);
